<template>
  <f7-page name="expired">
    <f7-navbar id="navbar" :title="$t('general_session-closed-label')" color="black">
      <f7-nav-right>
        <f7-icon f7="trash_circle"></f7-icon>
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar bottom>
      <small>{{ $t('copyright') }}</small>
    </f7-toolbar>

    <f7-block-title></f7-block-title>
    <f7-block>
      <Markdown :source="markdown" />
      <br>
      Sesiune terminata. Pentru siguranta ta iti recomandam sa inchizi navigatorul.
    </f7-block>

    <span>
      <f7-list>
        <f7-list-item :title="$t('expired_btn-new-session-label')" @click="home" link="#"></f7-list-item>
      </f7-list>
    </span>

  </f7-page>
</template>

<script>
  import { f7 } from 'framework7-vue';
  import Markdown from 'vue3-markdown-it';

  export default {
    props: {
      f7router: Object,
      markdown: String,
    },
    components: {
      Markdown,
    },
    methods: {
      home() {
        const self=this;
        f7.preloader.show();
        window.location.href='/';
      }
    }
  }
</script>
